import { abrirAlerta, ehAlerta } from 'dashboard/helper/destinoDoAlerta';

/**
 * PARA ONDE O CLIQUE NUMA NOTIFICAÇÃO LEVA — um lugar só (07/10/2026).
 *
 * A regra estava escrita duas vezes, no sino e na página, e já divergia: o
 * sino abria conversa pela caixa de entrada e a página pela tela de
 * conversas. Agora os dois chamam esta função.
 */
export const abrirNotificacao = (router, accountId, notificacao) => {
  const {
    notification_type: tipo,
    primary_actor_type: tipoDoAtor,
    primary_actor_id: idDoAtor,
  } = notificacao;
  // `primary_actor` pode vir nulo (alerta, registro apagado).
  const ator = notificacao.primary_actor || {};

  if (ehAlerta(tipo)) {
    abrirAlerta(router, notificacao);
    return;
  }
  if (tipoDoAtor === 'Conversation' && ator.id) {
    router.push(`/app/accounts/${accountId}/conversations/${ator.id}`);
  } else if (tipoDoAtor === 'LegalMovement') {
    router.push(
      ator.legal_process_id
        ? {
            name: 'legal_process_show',
            params: { accountId, processId: ator.legal_process_id },
          }
        : { name: 'legal_processes_index', params: { accountId } }
    );
  } else if (tipoDoAtor === 'Activity' || tipoDoAtor === 'LegalTask') {
    router.push({ name: 'appointments_agenda', params: { accountId } });
  } else if (tipoDoAtor === 'PipelineCard') {
    router.push({ name: 'pipeline_index', params: { accountId } });
  } else if (tipoDoAtor === 'InternalChat' && idDoAtor) {
    router.push({
      name: 'internal_chat_detail',
      params: { accountId, chatId: idDoAtor },
    });
  }
};
